import React, { useState, useRef, useEffect } from "react";
import CategoryNavItem from "../CategoryNavItem/CategoryNavItem";
import { useIntl } from "react-intl";

import "./styles.styl";

import ArrowLeftIcon from "jsx:../../../assets/svgs/arrow-left.svg";
import ArrowRightIcon from "jsx:../../../assets/svgs/arrow-right.svg";
import classNames from "classnames";

export default function CategoryNavList({
  productsByCategory,
  handleClick = () => {},
  currentSelected,
  currentSelectedMainCategory,
  categories,
  parentProductsByCategory,
  type,
}) {
  const listRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [selectedSubcategory, setSelectedSubcategory] =
    useState(currentSelected);

  if (type === "subcategory") {
    useEffect(() => {
      setSelectedSubcategory(currentSelected);
    }, [currentSelectedMainCategory]);
  }

  // Ideally this should come from backend
  // handle translation so if site is in english this is being handled as well.

  const categorieWithoutEmptyArr = Object.keys(productsByCategory ?? {}).map(
    (i) => {
      if (productsByCategory[i].length != 0) {
        return i;
      }
    },
  );
  let shouldAppendAll = false;
  if (
    type == "subcategory" &&
    parentProductsByCategory[currentSelectedMainCategory]
  ) {
    const checkIfFirstKeyIsEmptyString =
      Object.keys(parentProductsByCategory[currentSelectedMainCategory])[0] ===
      "";
    if (checkIfFirstKeyIsEmptyString) {
      shouldAppendAll = true;
    }
  }
  const categoriesWithAll =
    categorieWithoutEmptyArr.length > 1 && type === "subcategory"
      ? [...categorieWithoutEmptyArr]
      : categories;

  const handleListClick = (event) => {
    const category = event.target.getAttribute("data-category");
    if (category) {
      setSelectedSubcategory(category);
      handleClick(category);
    }
  };
  const handleScroll = () => {
    const container = listRef.current;

    if (container) {
      const atStart = container.scrollLeft === 0;
      const atEnd =
        Math.ceil(container.scrollLeft + container.clientWidth) >=
        container.scrollWidth;

      setCanScrollLeft(!atStart);
      setCanScrollRight(!atEnd);
    }
  };

  const scroll = (direction) => {
    const container = listRef.current;
    if (container) {
      const scrollAmount = 100;
      container.scrollBy({
        left: direction === "right" ? scrollAmount : -scrollAmount,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    handleScroll();
    const container = listRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    setSelectedSubcategory(currentSelected);
  }, [currentSelected]);

  return (
    <div className="categoryNavList__wrapper">
      {canScrollLeft && (
        <button
          className="scrollButton scrollButton__left"
          onClick={() => scroll("left")}
        >
          <ArrowLeftIcon aria-label="Scroll left" />
        </button>
      )}
      <div
        className={classNames(
          "categoryNavList__main categoryNavList__manage_space",
          { 
            categoryNavList__subCategory: type === "subcategory",
            categoryNavList__headerCategory: type === "title"
          },
        )}
        ref={listRef}
        onClick={handleListClick}
      >
        {categoriesWithAll &&
          categoriesWithAll.map((category) => (
            <CategoryNavItem
              key={category}
              selected={category === selectedSubcategory}
              canScrollLeft={canScrollLeft}
              canScrollRight={canScrollRight}
              type={type}
              content={category}
              dataCategory={category}
            />
          ))}
      </div>
      {canScrollRight && (
        <button
          className="scrollButton scrollButton__right"
          onClick={() => scroll("right")}
        >
          <ArrowRightIcon aria-label="Scroll right" />
        </button>
      )}
    </div>
  );
}
